import * as React from "react";
import type { SVGProps } from "react";
const Pharmacy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7311)">
      <g clipPath="url(#clip1_4362_7311)">
        <path
          fill="currentColor"
          d="M23.6391.5201c-.5157-.5953-1.3969-.6937-2.0297-.2296l-9.7828 7.2093h6.7922l4.9406-4.9406c.5531-.5531.5906-1.4437.075-2.039zM1.5 8.9998c-.8297 0-1.5.6703-1.5 1.5s.6703 1.5 1.5 1.5c0 3.8672 2.0344 6.9235 5.8078 8.2594a5.96 5.96 0 0 0-1.1203 2.2547c-.2062.8016.4828 1.4859 1.3125 1.4859h9c.8297 0 1.5188-.6843 1.3172-1.4859-.2109-.8344-.6-1.5984-1.1203-2.2547C20.4656 18.9233 22.5 15.867 22.5 11.9998c.8297 0 1.5-.6703 1.5-1.5s-.6703-1.5-1.5-1.5z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4362_7311">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4362_7311">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Pharmacy;
